export const navigation = [
  { route: '/', pageName: 'home' },
  { route: '/sportsbook', pageName: 'sportsbook'},
  { route: '/casino', pageName: 'casino'},
  { route: '/platform', pageName: 'platform' },
  { route: '/company', pageName: 'company' },
];
